/* eslint-disable @typescript-eslint/typedef */
import { createAction } from '@reduxjs/toolkit';

const addInputToHistory = createAction<string>('inputHistory/addInputToHistory');

export default {
  addInputToHistory
};
